// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__TUQby","actions":"GroupTable_actions__1uKcP","deleteModalFooter":"GroupTable_deleteModalFooter__2Kb8h"};